'use client';

import { FC, useEffect, useState } from 'react';

import { Loader } from '@/components';
import { Container } from './styled';

type StaticPageProps = {
  page: string;
};

export const StaticPageScreen: FC<StaticPageProps> = ({ page }) => {
  const [html, setHtml] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let isMounted = true;
    let scriptEl: HTMLScriptElement | null = null;
    let linkEl: HTMLLinkElement | null = null;

    const loadStaticPage = async () => {
      try {
        if (!isMounted) return;

        setLoading(true);

        const res = await fetch(`/static/${page}.html`);
        const html = await res.text();

        if (isMounted) setHtml(html);

        linkEl = document.createElement('link');
        linkEl.rel = 'stylesheet';
        linkEl.href = `/static/style.css`;
        document.head.appendChild(linkEl);

        scriptEl = document.createElement('script');
        scriptEl.src = `/static/script.js`;
        scriptEl.async = false;
        scriptEl.onload = () => {
          const evt = document.createEvent('Event');
          evt.initEvent('DOMContentLoaded', true, true);
          document.dispatchEvent(evt);
        };
        document.body.appendChild(scriptEl);
      } catch (err) {
        console.error(err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    void loadStaticPage();

    return () => {
      isMounted = false;
      if (linkEl && document.head.contains(linkEl)) {
        document.head.removeChild(linkEl);
      }
      if (scriptEl && document.body.contains(scriptEl)) {
        document.body.removeChild(scriptEl);
      }
    };
  }, [page]);

  if (loading) {
    return (
      <Container>
        <Loader />
      </Container>
    );
  }

  return <article dangerouslySetInnerHTML={{ __html: html }} />;
};
